import { xyJoinX } from '../xy/xyJoinX';
import { getSlots } from './utils/getSlots';
/**
 * Aligns data, can be used for spectra
 *
 * @param data - data
 * @param options - Options
 */
export function xyArrayAlign(data, options = {}) {
    const { delta = 1, requiredY = false } = options;
    data = data.map((spectrum) => xyJoinX(spectrum, { delta }));
    const slots = getSlots(data, options);
    let x = Float64Array.from(slots.map((slot) => slot.average));
    let ys = new Array(data.length).fill(0).map(() => new Float64Array(x.length));
    let positions = new Uint32Array(data.length);
    for (let i = 0; i < slots.length; i++) {
        let slot = slots[i];
        for (let j = 0; j < data.length; j++) {
            let spectrum = data[j];
            while (positions[j] < spectrum.x.length &&
                spectrum.x[positions[j]] <= slot.to) {
                ys[j][i] += spectrum.y[positions[j]];
                positions[j]++;
            }
        }
    }
    if (requiredY)
        return filterRequiredY(x, ys);
    return { x, ys };
}
function filterRequiredY(x, ys) {
    const newX = [];
    const newYs = new Array(ys.length).fill(0).map(() => []);
    for (let i = 0; i < x.length; i++) {
        if (ys.every((y) => y[i] !== 0)) {
            newX.push(x[i]);
            for (let j = 0; j < ys.length; j++) {
                newYs[j].push(ys[j][i]);
            }
        }
    }
    return { x: newX, ys: newYs };
}
//# sourceMappingURL=xyArrayAlign.js.map